var map = {
	"./PWA.svg": 1180,
	"./arrow-left.svg": 24663,
	"./arrow-right.svg": 46034,
	"./arrow-share.svg": 31061,
	"./arrow-to-web-view-dots.svg": 31917,
	"./bolt.svg": 23825,
	"./chat-emoji.svg": 81651,
	"./chat-for-you-decoration-arrow.svg": 80277,
	"./chat-info/attachments.svg": 18292,
	"./chat-info/chat.svg": 51020,
	"./chat-info/photo.svg": 88470,
	"./chat-info/present.svg": 93511,
	"./chat-send.svg": 4129,
	"./checkbox-check.svg": 7916,
	"./chevron-left.svg": 93525,
	"./clip.svg": 10962,
	"./clock.svg": 8162,
	"./close-arrow.svg": 13840,
	"./coin.svg": 14263,
	"./collapse.svg": 69189,
	"./contact-sales.svg": 35083,
	"./cross-circle.svg": 85029,
	"./cross.svg": 48984,
	"./cross2.svg": 24282,
	"./dialog/dont-know.svg": 2842,
	"./dialog/flirty.svg": 15029,
	"./dialog/loyal-fan.svg": 11806,
	"./dialog/pen-pal.svg": 27240,
	"./dialog/romantic.svg": 47290,
	"./dialog/serious.svg": 68959,
	"./expand.svg": 28680,
	"./eye.svg": 67839,
	"./flag.svg": 93822,
	"./hamburger.svg": 41973,
	"./heart.svg": 18476,
	"./heart2.svg": 10518,
	"./i_autoreply.svg": 61511,
	"./i_content.svg": 34003,
	"./i_delete.svg": 85973,
	"./i_desktop.svg": 2028,
	"./i_mobile.svg": 54562,
	"./i_payments.svg": 76497,
	"./info.svg": 29644,
	"./instagram.svg": 9396,
	"./lists/arrow.svg": 22389,
	"./lists/big-arrow.svg": 65272,
	"./lists/edit.svg": 49938,
	"./lists/notifications.svg": 73066,
	"./lists/privacy.svg": 31230,
	"./lists/wallet.svg": 53713,
	"./location_on.svg": 30907,
	"./lock-2.svg": 18996,
	"./lock-brand.svg": 40641,
	"./lock-smile-decoration-big.svg": 16636,
	"./lock-smile-decoration.svg": 42033,
	"./lock.svg": 26885,
	"./logo-name.svg": 36887,
	"./logo-small.svg": 78903,
	"./me/contact_us.svg": 73594,
	"./me/support.svg": 23653,
	"./one2fan-blog.svg": 90990,
	"./photo-2.svg": 61225,
	"./photo.svg": 85076,
	"./picture.svg": 29326,
	"./play-2.svg": 48007,
	"./play-video-original.svg": 69424,
	"./play-video.svg": 61764,
	"./present.svg": 61305,
	"./profile.svg": 69263,
	"./pwa/android-pwa-1.svg": 67777,
	"./pwa/download-2.svg": 99082,
	"./pwa/download.svg": 43407,
	"./pwa/ios-pwa-1.svg": 89427,
	"./quiz-decoration.svg": 75950,
	"./search.svg": 17196,
	"./send.svg": 31770,
	"./share-outline.svg": 29212,
	"./share.svg": 3001,
	"./share2.svg": 11753,
	"./star.svg": 81104,
	"./swipe-arrow-top.svg": 72128,
	"./swipe-arrow-top2.svg": 99282,
	"./tail-tip-companion.svg": 3383,
	"./tail-tip.svg": 52542,
	"./tail.svg": 89150,
	"./tail_hi.svg": 53436,
	"./tail_me.svg": 16059,
	"./tail_me_need_pay.svg": 73189,
	"./tail_pink.svg": 81549,
	"./tail_pink_me.svg": 15442,
	"./tail_pink_short.svg": 76558,
	"./tail_promo.svg": 75342,
	"./tail_promo_short.svg": 84109,
	"./tiktok.svg": 40534,
	"./tiktok2.svg": 58616,
	"./timer.svg": 13787,
	"./times-circle.svg": 44151,
	"./tops/bg-copper.svg": 13904,
	"./tops/bg-gold.svg": 63021,
	"./tops/bg-silver.svg": 8004,
	"./tops/copper-medal.svg": 18602,
	"./tops/gold-medal.svg": 53003,
	"./tops/silver-medal.svg": 18318,
	"./translate.svg": 52290,
	"./trash.svg": 80022,
	"./union.svg": 59493,
	"./user.svg": 50833,
	"./verified-hovered.svg": 62150,
	"./verified.svg": 4183,
	"./viewed.svg": 65784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80064;